import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { Flex, PageContainer } from "src/styled";
import { useGetApi } from "../../../hooks";
import { getYachtId } from "../../../utils";
import { FormProvider, useForm } from "react-hook-form";
import { INMEAForm } from "../../../interfaces/NMEA";
import { dataMapper } from "../../../components/pages/Settings/NMEA/NMEA.utils";
import { useEffect } from "react";
import NMEACredentials from "../../../components/pages/Settings/NMEA/NMEACredentials";
import { Grid, Loader } from "@mantine/core";
import NMEAMapping from "../../../components/pages/Settings/NMEA/NMEAMapping/NMEAMapping";
import NMEASaveButton from "../../../components/pages/Settings/NMEA/NMEASaveButton";

const NMEA = () => {
  const methods = useForm<INMEAForm>();

  const { data, isLoading, refetch } = useGetApi({
    request: "get-nmea-config",
    body: {
      params: {
        yachtid: getYachtId(),
      },
    },
    mapper: dataMapper,
  });

  useEffect(() => {
    if (data) {
      methods.reset(data.form);
    }
  }, [data, methods]);

  return (
    <PageContainer>
      <FormProvider {...methods}>
        <Breadcrumbs>
          <Flex justify="flex-end" w="100%">
            <NMEASaveButton refetch={refetch} />
          </Flex>
        </Breadcrumbs>
        {isLoading ? (
          <Flex w="100%" h="100%" justify="center" align="center">
            <Loader />
          </Flex>
        ) : (
          <Grid columns={2} mt={20}>
            <NMEACredentials
              providers={data?.providers ?? []}
              watch={methods.watch}
            />
            <NMEAMapping
              logbooks={data?.logbooks ?? []}
              watch={methods.watch}
              disabled={!data?.isMappingAvailable}
            />
          </Grid>
        )}
      </FormProvider>
    </PageContainer>
  );
};

export default NMEA;
